import {
  LogoXero,
  LogoQuickbooks,
  LogoSage,
  LogoXeroRound,
  LogoSageRound,
  LogoQuickbooksRound,
  LogoExperianRound,
} from '@capitalise/ui-design-system';
import QuickBooksLogo from 'assets/svgs/quickbooks-logo.svg';
import SageLogo from 'assets/svgs/sage-logo.svg';
import XeroLogo from 'assets/svgs/xero-logo.svg';
import ExperianLogo from 'assets/svgs/experian-logo.svg';

export const IntegrationType = Object.freeze({
  quickbooks: 'quickbooks',
  sage: 'sage',
  xero: 'xero',
});

export const IntegrationTypeLabel = Object.freeze({
  [IntegrationType.quickbooks]: 'QuickBooks',
  [IntegrationType.sage]: 'Sage',
  [IntegrationType.xero]: 'Xero',
});

export const IntegrationTypeLogo = Object.freeze({
  [IntegrationType.quickbooks]: QuickBooksLogo,
  [IntegrationType.sage]: SageLogo,
  [IntegrationType.xero]: XeroLogo,
});

export const NewIntegrationTypeLogo = Object.freeze({
  [IntegrationType.xero]: <LogoXero />,
  [IntegrationType.sage]: <LogoSage />,
  [IntegrationType.quickbooks]: <LogoQuickbooks />,
});

export const ConnectionLabels = Object.freeze({
  [IntegrationType.quickbooks]: 'Connect to cloud accounting service',
  [IntegrationType.sage]: 'Connect to cloud accounting service',
  [IntegrationType.xero]: 'Connect to cloud accounting service',
});

export const RoundIntegrationTypeLogo = Object.freeze({
  [IntegrationType.xero]: <LogoXeroRound height="32px" width="32px" />,
  [IntegrationType.sage]: <LogoSageRound height="32px" width="32px" />,
  [IntegrationType.quickbooks]: <LogoQuickbooksRound height="32px" width="32px" />,
});

export const CreditIntegrationType = Object.freeze({
  experian: 'experian',
});

export const CreditIntegrationTypeLabel = Object.freeze({
  [CreditIntegrationType.experian]: 'Experian',
});

export const CreditIntegrationTypeLogo = Object.freeze({
  [CreditIntegrationType.experian]: <LogoExperianRound height="32px" width="32px" />,
});
